export const FONT_SIZE = {
	regular: "1rem", // 16px
	large: "1.25rem", // 18px
	xxLarge: "1.5rem", // 24px
	xxxLarge: "2rem", // 32px
	small: ".825rem", // 14px
	xxSmall: ".625rem", // 10px
	xxxSmall: ".5rem", // 8px
};

export const FONT_STACK = {
	primary: "Montserrat",
};

export const MARGINS = {
	regular: "1rem",
	xxLarge: "1.5rem",
	xxxLarge: "2rem",
	small: ".75rem",
	xSmall: ".5rem",
};

export const PADDINGS = {
	regular: "1rem",
	xxLarge: "1.5rem",
	xxxLarge: "2rem",
	small: ".75rem",
	xSmall: ".5rem",
};

export const COLORS = {
	appPink: "#FF5A62",
	appPinkSaturated: "#ff2e3e",
	appPurpleBlue: "#3D50DF",
	appGreenGauze: "#7BD6AA",
	appGentleGray: "#C4C4C4",
	appGray10: "rgba(50,50,50, 0.1)",
	appGray20: "rgba(50,50,50, 0.2)",
	appGray30: "rgba(50,50,50, 0.3)",
	appGray40: "rgba(50,50,50, 0.4)",
	appGray50: "rgba(50,50,50, 0.5)",
	appGray60: "rgba(50,50,50, 0.6)",
	appGray70: "rgba(50,50,50, 0.7)",
	appGray80: "rgba(50,50,50, 0.8)",
	appGray90: "rgba(50,50,50, 0.9)",
	appTextDark: "#323232",
	appTextFaded: "#9797BD",
	appLightPink: "#FFEAED",
	appBtnBackground: "#F15E5F",
	appPlaceholder: "#9797BD",
};

export const MEDIA_BREAKPOINTS = {
	desktop: 1280,
	smallDesktop: 1080,
	tablets: 968,
	smallTablet: 768,
	largeMobile: 540,
	mobile: 400,
};

export const TRANSITIONS = {
	fast: `0.25s`,
	medium: `0.5s`,
	slow: `0.75s`,
	snail: `1s`,
	bounce: `cubic-bezier(.8,0,.19,1.46)`,
	primary: `all 0.25s cubic-bezier(.8,0,.19,1.46)`,
};
